<template>
  <!-- Navigation-->
  <nav class="navbar navbar-expand-lg navbar-dark bg-black bg-opacity-75 position-fixed top-0 w-100">
    <div class="container px-2">
      <a class="navbar-brand" href="index.html">
        <img src="@/assets/img/logo.png" class="logo">
        <div class="float-end">
          <p class="m-0 text-center title">DJ Medi</p>
          <small class="sub-title text-center m-0 d-block">Hochzeit &middot; Event &middot; Geburtstag</small>
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item"><a class="nav-link text-white" href="#Startseite">Startseite</a></li>
          <li class="nav-item"><a class="nav-link text-white" href="#Preise">Preise</a></li>
          <li class="nav-item"><a class="nav-link text-white" href="#Fotobox">Fotobox</a></li>
          <li class="nav-item"><a class="nav-link text-white" href="#Galerie">Galerie</a></li>
          <li class="nav-item"><a class="nav-link text-white" href="#Infos">Infos</a></li>
          <li class="nav-item"><a class="nav-link text-white" href="#Kontakt">Kontakt</a></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
</script>

<style scoped>
  nav {
    z-index: 1000;
  }
  .navbar-toggler {
    border:none;
  }
  .nav-link:hover {
    color: var(--bs-pink) !important;
  }
  .logo {
    height: 4rem;
    margin-right: 1rem;
  }
  .title {
    margin-top: 0.35rem !important;
  }
  .sub-title {
    font-size: 0.75rem;
  }
</style>